export const AdminSidebarData = [
  {
    title: "User Orders",
    path: "/admin/user/orders",
  },
  {
    title: "Corporate Accounts",
    path: "/admin/corporate/accounts",
  },
  {
    title: "User Accounts",
    path: "/admin/user/accounts",
  },
  {
    title: "Quote Requests",
    path: "/admin/quoterequests",
  },
  {
    title: "ACGT Cards",
    path: "/admin/acgtcards",
  },
  {
    title: "Settings",
    path: "/admin/settings",
  },
  {
    title: "Pop Up Messages",
    path: "/admin/popups",
	},
	{
    title: "Discount Coupons",
    path: "/admin/discounts",
	},
	{
		title: "Referrals",
		path: "/admin/referrals",
	},
	{
		title: "Dropboxes",
		path: "/admin/dropboxes",
	},
	{
		title: "Statistics",
		path: "/admin/stats",
	},
  { title: "Dashboard", path: "/dashboard" },
];
